import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { List, ListItem } from './index';
import Headline3 from '../Typography/Heading/Headline3';
import Headline6 from '../Typography/Heading/Headline6';
import breakpoints from '../Theme/breakpoints';

const ListItemVisualsContainer = styled.div`
  text-align: center;
  margin-right: 24px;
`;

const ListItemDate = ({ day, month }) => (
  <ListItemVisualsContainer>
    <Headline3 tag="div" color="textSecondary">
      {day}
    </Headline3>
    <Headline6 tag="div" color="textSecondary">
      {month}
    </Headline6>
  </ListItemVisualsContainer>
);

ListItemDate.propTypes = {
  /** Sets the day of the month */
  day: PropTypes.string.isRequired,
  /** Sets the month  */
  month: PropTypes.string.isRequired,
};

const StyledListItem = styled(ListItem)`
  &&& {
    justify-content: space-between;
    padding: 24px 16px;

    @media (min-width: ${breakpoints.md}px) {
      padding: 24px 0 0;
    }
  }
`;

const ListItemImageContainer = styled.div`
  &&& {
    margin-left: 16px;
  }
`;

const SpaceBetweenListItem = styled(ListItem)`
  &&& {
    justify-content: space-between;
    padding: 24px 16px;
    border-bottom: 1px solid var(--grey-light);
  }

  div:last-of-type {
    text-align: right;
  }
`;

const TableListHeading = styled.div`
  && {
    margin: 0;
    text-transform: uppercase;
    font-size: var(--size-body1);
    font-weight: normal; /* fixes font-weight issue Firefox */
    color: var(--black-high);
    font-family: var(--font-secondary);
    display: block;
  }
`;

const TableList = ({
  className, listItemClassName, headings, rows,
}) => (
  <List className={className}>
    <SpaceBetweenListItem className={listItemClassName}>
      {headings.map((heading) => (
        <TableListHeading key={heading}>
          {heading}
        </TableListHeading>
      ))}
    </SpaceBetweenListItem>
    {rows.map((row, rowIndex) => {
      const rowKey = `row-${rowIndex}`;
      return (
        <Fragment key={rowKey}>
          <SpaceBetweenListItem
            className={listItemClassName}
          >
            {row.map((cell, cellIndex) => {
              const cellKey = `row-${rowIndex}-cell-${cellIndex}`;
              return (
                <div key={cellKey}>
                  {cell}
                </div>
              );
            })}
          </SpaceBetweenListItem>
        </Fragment>
      );
    })}
  </List>
);

TableList.propTypes = {
  className: PropTypes.string,
  listItemClassName: PropTypes.string,
  headings: PropTypes.arrayOf(PropTypes.string),
  rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.node)),
};

TableList.defaultProps = {
  className: 'fu-mdc-list',
  listItemClassName: 'fu-list-item-content',
  headings: [],
  rows: [],
};

export {
  ListItemDate,
  StyledListItem,
  ListItemImageContainer,
  TableListHeading,
  TableList,
};
